<template>
     <div v-html = "payGateWay">{{payGateWay}}</div>
</template>

<script>
import { airPay} from "@/api/enterprise/index";
    export default {
        name: 'payGateWay',
        data(){
            return {
                payGateWay:''
            }
        } ,
        mounted () {
             airPay({id:this.$route.query.id,type:'mobile'},'enterprise')
             .then(res =>{
              this.payGateWay = res.data
            this.$nextTick(()=> {
               document.forms[0].submit()
            })
             })
        }
    }
</script>
